
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnBOMGrid extends Serenity.EntityGrid<POSApprovalReturnBOMRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalReturnBOM'; }
        protected getDialogType() { return POSApprovalReturnBOMDialog; }
        protected getIdProperty() { return POSApprovalReturnBOMRow.idProperty; }
        protected getInsertPermission() { return POSApprovalReturnBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalReturnBOMRow.localTextPrefix; }
        protected getService() { return POSApprovalReturnBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}